import { render, staticRenderFns } from "./KeybeAutocomplete.vue?vue&type=template&id=497a2d60&"
import script from "./KeybeAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./KeybeAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports